import { render, staticRenderFns } from "./ExclusaoManutencao.vue?vue&type=template&id=4cc80b1d&scoped=true&"
import script from "./ExclusaoManutencao.vue?vue&type=script&lang=js&"
export * from "./ExclusaoManutencao.vue?vue&type=script&lang=js&"
import style0 from "./ExclusaoManutencao.vue?vue&type=style&index=0&id=4cc80b1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc80b1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
